<template>
  <div class="content">
    <el-dialog
      title="管理员订单"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="80%"
      @close="emitClose"
    >
      <div style="margin-bottom:24px">
        <el-button type="primary" @click="fetchTableList()">刷新</el-button>
      </div>
      <el-table
        :data="tableData"
        class="table"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="用户信息"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            {{scope.row.uid}}/{{scope.row.nickname}}
          </template>
        </el-table-column>
        <el-table-column
          prop="product_name"
          label="商品名称"
          align="center"
          width="300"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goods_name"
          label="商品类型"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatRef_type(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="订单金额"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.price }}元</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              type="warning"
              size="mini"
              v-show="scope.row.status==0"
            >待执行</el-tag>
            <el-tag
              type="success"
              size="mini"
              v-show="scope.row.status==1"
            >成功</el-tag>
            <el-tag
              type="danger"
              size="mini"
              v-show="scope.row.status==2"
            >失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="fail_reason"
          label="备注"
          align="center"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="创建人"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatAdmin_id(scope.row.admin_id) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="60"
          align="center"
        >
          <template slot-scope="scope">
            <el-link
              type="danger
            "
              @click="handleRemove(scope.row.id)"
              :underline="false"
            >删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="emitClose"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminOrderList, deleteAdminOrderList } from "@/api/member";
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      tableData: [],
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 0,
    };
  },
  mounted() {
    this.fetchTableList()
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
    },
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    fetchTableList() {
      adminOrderList(this.query).then((res) => {
        this.tableData = res.list || [];
        this.pageTotal = res.count
      });
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchTableList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchTableList();
    },
    formatRef_type(row) {
      const obj = {
        0: "无",
        1: "课程",
        2: "题库",
        3: "专栏",
        4: "资料",
        5: "文章",
        6: "学长",
      };
      return obj[row.ref_type] || "";
    },
    formatAdmin_id(id) {
      if (id) {
        return this.$store.state.adminList.find((v) => {
          return v.id == id;
        }).nickname;
      } else {
        return "无";
      }
    },
    // 删除
    handleRemove(id) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        deleteAdminOrderList({ id: id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchTableList()
        })
      }).catch(() => { })
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}
.el-link {
  font-size: 12px;
}
</style>